import { render, staticRenderFns } from "./FilterSectionTitle.vue?vue&type=template&id=0df45cda"
import script from "./FilterSectionTitle.vue?vue&type=script&lang=ts"
export * from "./FilterSectionTitle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports